import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { CustomMaterialTable, ToggleButtonGroup, ExportButton, COLORS } from "components";
import { getEmissionsExport, SitesEmissionsQuery } from "api";
import { validateExportParams } from "utils";
import { SITE_EMISSIONS_COLUMNS_MAIN } from "./columns";

export const EmissionTableComponent = ({
  complementaryColumns = [],
  isDisaggregated,
  setIsDisaggregated,
  tableData,
  exportParams,
}: {
  complementaryColumns?: any;
  isDisaggregated: boolean;
  setIsDisaggregated: (isDisaggregated: boolean) => void,
  tableData: any;
  exportParams?: SitesEmissionsQuery;
}) => {

  const columns = useMemo(
    () => [...SITE_EMISSIONS_COLUMNS_MAIN, ...complementaryColumns],
    [complementaryColumns]
  );

  const toggleOptions = [
    { value: 'Aggregated', label: 'Aggregated' },
    { value: 'Monthly', label: 'Monthly' }
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 3, width: "100%" }}>
      <Box sx={{ display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}>
        <ToggleButtonGroup
          options={toggleOptions}
          selectedValue={isDisaggregated ? "Monthly" : "Aggregated"}
          onValueChange={(value) => setIsDisaggregated(value === "Monthly")}
        />
        {exportParams && (
          <ExportButton
            exportFunction={getEmissionsExport}
            exportParams={exportParams}
            exportText="Export Excel"
            exportTitle="emissions_summary_export"
            exportingText="Exporting..."
            successMessage="Export completed successfully."
            errorMessage="Failed to export emissions data."
            isZipFile={false}
            fileExtension=".xlsx"
            onBeforeExport={validateExportParams}
            sx={{
              width: '200px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: "500"
            }}
          />
        )}
      </Box>
      <CustomMaterialTable
        columns={columns}
        data={tableData}
        containerSx={{
          height: "calc(100vh - 445px)",
          minHeight: "200px",
          width: "100%",
          maxWidth: "calc(100vw - 149px)",
          "& thead tr th": {
            color: COLORS.Mainblue,
          },
        }}

        enableColumnResizing
        enableDensityToggle={false}
        initialState={{ density: "compact" }}
        enablePagination={false}
        enableGrouping
      />
    </Box>
  )
}
